declare global {
    interface Window {
      env: any
    }
  }
  
  type EnvType = {
    REACT_APP_ENDPOINTS__HUB: string,
    REACT_APP_ENDPOINTS__HUBEXTERN: string,
    REACT_APP_ENDPOINTS__DOWNLOADLOG: string,
    REACT_APP_ENDPOINTS__SNAPSHOT: string,
    REACT_APP_ENDPOINTS__DLZIP: string
  }
  export const env: EnvType = { ...process.env, ...window.env }

